import merge from "lodash/fp/merge";
import log from "loglevel";

interface Config {
  HOST: string;
  API_URL: string;
  DEBUG: boolean;
  TRACKING_ENABLED: boolean;
  mixpanel: {
    HOST: string;
    ID: string;
    COOKIE_DOMAIN: string;
  };
  ga: {
    ID: string;
    API_ID: string;
  };
  sentry: {
    DSN: string;
  };
}

const development: Partial<Config> = {
  HOST: import.meta.env.VITE_APP_HOST ?? "http://localhost:3000",
  TRACKING_ENABLED: false,
  API_URL: "https://localhost:8000",
  DEBUG: true,
  mixpanel: {
    HOST: "https://moxy.read.ai",
    ID: "d34b18861b5c0ad5ffe89d8d307bdcdc",
    COOKIE_DOMAIN: "localhost:3000",
  },
  ga: {
    ID: "G-JQN958QXJF",
    API_ID: "ftD0Tj1_RtSOSRfKRMtDzw",
  },
};

const staging: Partial<Config> = {
  HOST: "https://stg-app.read.ai",
  API_URL: "https://stg-api.read.ai",
  DEBUG: true,
  mixpanel: {
    HOST: "https://moxy.read.ai",
    ID: "d34b18861b5c0ad5ffe89d8d307bdcdc",
    COOKIE_DOMAIN: import.meta.env.VITE_APP_COOKIE_DOMAIN ?? "stg-api.read.ai",
  },
  ga: {
    ID: "G-JQN958QXJF",
    API_ID: "ftD0Tj1_RtSOSRfKRMtDzw",
  },
};

const production: Partial<Config> = {
  HOST: "https://app.read.ai",
  API_URL: "https://api.read.ai",
  mixpanel: {
    HOST: "https://moxy.read.ai",
    ID: "68e743b21f2eb5cbbfd12657136457ad",
    COOKIE_DOMAIN: "api.read.ai",
  },
  ga: {
    ID: "G-2Y1H5ZJMBK",
    API_ID: "5PFjOer8TjarrxfkHia2Fg",
  },
};

const CONFIGS = {
  development,
  staging,
  production,
};

const common: Config = {
  HOST: "",
  API_URL: "",
  DEBUG: false,
  TRACKING_ENABLED: true,
  mixpanel: {
    HOST: "https://moxy.read.ai",
    ID: "",
    COOKIE_DOMAIN: "",
  },
  ga: {
    ID: "",
    API_ID: "",
  },
  sentry: {
    DSN: "https://db61230961b34c97bb5e811a937e0625@o992397.ingest.sentry.io/4503938822635520",
  },
};

const stage = import.meta.env.VITE_APP_STAGE ?? "development";

if (!(stage in CONFIGS)) {
  throw new Error(
    `unknown config environment ${import.meta.env.VITE_APP_STAGE}`
  );
}

let config = CONFIGS[stage as keyof typeof CONFIGS] || development;

if (!stage || stage === "development") {
  log.setDefaultLevel("trace");
} else {
  log.setDefaultLevel(stage === "production" ? "silent" : "debug");
}

config = merge({ ...common }, config);
export default config as Config;
